import React from "react";

export default function ForCheck1() {
  return <div>ForCheck1</div>;
}
